import gql from "graphql-tag"

export const VALIDATE_CUSTOM_PAYMENT = gql`
  query validateCustomPayment($baseUrl: String!, $authUrl: String!, $clientId: String!, $clientSecret: String!) {
    Configuration {
      validate {
        customPayment(baseUrl: $baseUrl, authUrl: $authUrl, clientId: $clientId, clientSecret: $clientSecret) {
          errorMessage
          valid
        }
      }
    }
  }
`
